import type { ReactNode } from 'react'
import { Navigate } from 'react-router'

import { useConsumerClaimsEnabled } from '@/consumer/hooks/use-consumer-claims-enabled'

/** Keeps a typed or bookmarked claim-creation URL out when claims are off. */
export function RequireConsumerClaims({ children }: { children: ReactNode }) {
  const enabled = useConsumerClaimsEnabled()
  if (!enabled) return <Navigate to="/" replace />
  return <>{children}</>
}
